<template>
    <form class="form-horizontal"  @submit.prevent="submit()">
        <div class="form-group" >
            <label for=""  class="col-sm-2 control-label">URL indexada en sitemap</label>
            <div class="col-sm-10" v-if="this.existsitemap === false">
                    <p class="control-label" style="text-align: left">No.</p>
            </div>
            <div class="col-sm-10" v-else-if="'message' in this.existsitemap">
                    <p class="control-label" style="text-align: left">{{ this.existsitemap.message }} </p>
            </div>
            <div class="col-sm-10" v-else-if="'createdAt' in this.existsitemap">
                    <p class="control-label" style="text-align: left">Si, actualizado el {{ this.existsitemap.createdAt }} </p>
            </div>
        </div>
        <div class="form-group" >
            <label for=""  class="col-sm-2 control-label">Page title</label>
            <div class="col-sm-10">
                <el-popover placement="bottom" title="Page title" width="200" trigger="click" content="Título con que aparecera en la búsquedas como Google " >
                    <el-button slot="reference">?</el-button>
                </el-popover>
            </div>
        </div>
        <div class="form-group" :class="{ 'has-error': errors['custom_title'] }">
            <label for="" class="col-sm-2 control-label">Custom page title</label>
            <div class="col-sm-10 ">
                 <el-switch
                    v-model="data.custom_title_active" 
                    on-text="SI"
                    off-text="NO"                    
                >
                </el-switch>
                <br>  
            </div>
            <div class="col-sm-offset-2 col-sm-10">
                <template  v-if="data.custom_title_active">
                    <textarea type="text"  v-model="data.custom_title" class="form-control" name="custom-title" id="custom-page-title" style="height: 100px;"  ></textarea>
                    <div class="help-block" v-for="e in errors['custom_title']">{{ e }}</div>
                </template>
                <template v-else>
                   {{data.title}} 
                </template>
            </div>
        </div>
        <div class="form-group">
            <label for=""  class="col-sm-2 control-label">Meta description</label>
            <div class="col-sm-10">
                <el-popover placement="bottom" title="Meta description" width="200" trigger="click" content="Descripción o resumen del contenido de la página" >
                    <el-button slot="reference">?</el-button>
                </el-popover>
            </div>
        </div>
        <div class="form-group "  :class="{ 'has-error': errors['custom_meta'] }">
            <label for="" class="col-sm-2 control-label">Custom Meta description</label>
            <div class="col-sm-10 ">
                 <el-switch
                    v-model="data.custom_meta_active" 
                    on-text="SI"
                    off-text="NO"                    
                >
                </el-switch>
                 <br>  
            </div>
            <div class="col-sm-offset-2 col-sm-10">
                 <template  v-if="data.custom_meta_active">
                    <textarea type="text"  v-model="data.custom_meta" class="form-control" name="customMetaText" id="customMetaText" style="height: 150px;"  ></textarea>
                    <div class="help-block" v-for="e in errors['custom_title']">{{ e }}</div>
                </template>
                <template v-else>
                   <div style="white-space: pre-line;">{{attrseo.description}} </div>
                </template>
              
                <br>
            </div>
        </div>

         <div class="form-group">
            <label for=""  class="col-sm-2 control-label">Keywords</label>
            <div class="col-sm-10">
                <div class="chip-container" >
                    <div class="chip" v-for="(chip, i) of chips" :key="chip.label">
                        {{ chip }}
                        <i class="material-icons" @click="deleteChip(i)">clear</i>
                    </div>
                    <input ref="keywrd"    v-model="currentInput"  @keyup="evalKey"  @keydown.delete="backspaceDelete"  />
                </div>
                <div class="help-block">Ingrese keywords separados por comas (,) .</div>
                <div class="help-block" v-for="e in errors['keywords']">{{ e }}</div>
            </div>
        </div>
         <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" :href="'backend/fichas/'+ this.attrseo.id " >Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss">
.error {
  color: red;
}
.el-popover {
  color: black;
}
.preview{
    border-style: dotted;
    border-width: 1px;
    padding: 10px;
}
</style>
<script>
import ElRadio from "element-ui/lib/radio";
import ElPopover from "element-ui/lib/popover";
import ElSwitch from 'element-ui/lib/switch';

export default {
    data:function(){
        const attrseo = _.cloneDeep(this.attrseo);
        var metaText = '';
        var customtitle = '';

        if(!attrseo.custom_title_active)
            attrseo.custom_title = attrseo.title;
        
        if(!attrseo.custom_meta_active)
            attrseo.custom_meta= attrseo.description;

        return {
            data: attrseo,
            chips: [],
            currentInput: "",
            set: {
                type: Boolean,
                default: true
            },
            addkeyword:false,
            errors: {}
        }
    },
    props:['attrseo','existsitemap'],
    components:{
        ElSwitch,
        ElPopover 
    },
    created:function() {
        var keywords = this.attrseo.keywords.split(",");
        var filtered = keywords.filter(function(e) {
        return e;
        });
        filtered = filtered.map(function(s) {
        return String.prototype.trim.apply(s);
        });
        this.chips = filtered;
        this.data.keywords = this.chips.join(", ");

    },
    
    methods:{
        submit:function(){
            var keywordInput = this.currentInput.trim();
            var errores = {};

            if (keywordInput.length > 0) {
                this.saveChip();
            }else{
                if(this.data.custom_title_active ){
                    if(this.data.custom_title == null || this.data.custom_title == "undefined"){
                         errores['custom_title'] = ['Debe ingresar custom page title'];
                    }else if(this.data.custom_title.length == 0){
                            errores['custom_title'] = ['Debe ingresar custom page title'];
                        }
                }else
                    this.data.custom_title = this.attrseo.custom_title;
    
                if(this.data.custom_meta_active){
                    if(this.data.custom_meta == null || this.data.custom_meta == "undefined"){
                        errores['custom_meta'] = ['Debe ingresar custom meta description']
                    }else if(this.data.custom_meta.length == 0){
                        errores['custom_meta'] = ['Debe ingresar custom meta description']
                    }
                }else
                    this.data.custom_meta = this.attrseo.description;
                
                if(Object.entries(errores).length === 0 ){
                    axios({
                        url: 'backend/fichas/' + this.attrseo.id +'/seo' ,
                        method: 'PUT',
                        data: this.data,
                    }).then(function(response){
                        window.location.replace(response.data.redirect);
                    }).catch(function(error){
                        this.errors = error.response.data.errors;
                    });
                }else{
                    this.errors = errores;
                    this.$message.error("Revise los errores en el formulario para continuar.");
                    return false;
                }
            }


        },
        setFocus() {
            this.$refs.keywrd.focus();
        },
        saveChip() {
            const { chips, currentInput, set } = this;
            ((set && chips.indexOf(currentInput) === -1) || !set) && chips.push(currentInput);
            this.currentInput = "";
            this.updateData();
        },
        deleteChip(index) {
            this.chips.splice(index, 1);
            this.updateData();
        },
        evalKey: function(event) {
            if (event.key === ",") {
                this.currentInput = this.currentInput.split(",").join("");
                if (this.currentInput.length) {
                    this.saveChip();
                    this.addkeyword = true;
                }
            }
        },
        backspaceDelete({ which }) {
            which == 8 &&
                this.currentInput === "" &&
                this.chips.splice(this.chips.length - 1);
            this.updateData();
        },
        updateData() {
        this.data.keywords = this.chips.join(", ");
        }
    }
}
</script>